export class ItemInstallPositionType {
  static getFormInstallPositionTypeName (type, installPositionList) {
    // 如果有提供 installPositionList，則從列表中查找對應的名稱
    if (installPositionList && installPositionList.length > 0) {
      const position = installPositionList.find(item => item.Type === type)
      if (position) {
        return position.Name
      }
    }
    return ''
  }
}
